// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-form {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 8px 0 8px;
    transition: 0.3s;
    border-bottom: 2px solid rgba(0, 0, 0, 0.87);
    padding: 0;
}

.message-form:focus-within {
    border-bottom: 2px solid #3f51b5;
}

.message-form .message-form__send,
.message-form .message-form__input {
    height: 75%;
    outline: none;
    border: none;
}

.message-form .message-form__input {
    resize: none;
    border: none;
    margin-right: 3px;
    margin-bottom: 0px;
    vertical-align: middle;
    transition: 0.3s;
}

.message-form .message-form__input:hover,
.message-form .message-form__input:focus {
    border: none !important;
    box-shadow: none !important;
}

.message-form .message-form__send {
    background: none;
    box-shadow: none;
}

.message-form .message-form__send:hover {
    border: none;
    box-shadow: none;
}

.message-form__send .material-icons {
    color: #718093;
    transition: 0.3s;
}

.message-form__send .material-icons:hover {
    color: #2f3640;
}

.message-form textarea.scalable-text-input {
    padding-bottom: 5px;
    height: auto;
    margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-widget/message-input/MessageInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".message-form {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    margin: 10px 8px 0 8px;\r\n    transition: 0.3s;\r\n    border-bottom: 2px solid rgba(0, 0, 0, 0.87);\r\n    padding: 0;\r\n}\r\n\r\n.message-form:focus-within {\r\n    border-bottom: 2px solid #3f51b5;\r\n}\r\n\r\n.message-form .message-form__send,\r\n.message-form .message-form__input {\r\n    height: 75%;\r\n    outline: none;\r\n    border: none;\r\n}\r\n\r\n.message-form .message-form__input {\r\n    resize: none;\r\n    border: none;\r\n    margin-right: 3px;\r\n    margin-bottom: 0px;\r\n    vertical-align: middle;\r\n    transition: 0.3s;\r\n}\r\n\r\n.message-form .message-form__input:hover,\r\n.message-form .message-form__input:focus {\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.message-form .message-form__send {\r\n    background: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.message-form .message-form__send:hover {\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.message-form__send .material-icons {\r\n    color: #718093;\r\n    transition: 0.3s;\r\n}\r\n\r\n.message-form__send .material-icons:hover {\r\n    color: #2f3640;\r\n}\r\n\r\n.message-form textarea.scalable-text-input {\r\n    padding-bottom: 5px;\r\n    height: auto;\r\n    margin-top: 16px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
